import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "error-message__container"
}
const _hoisted_2 = { class: "error-message__text" }

import { i18n } from '@/i18n';



export default /*@__PURE__*/_defineComponent({
  __name: 'ErrorMessage',
  props: {
    isError: { type: Boolean },
    errorMessage: {}
  },
  setup(__props: any) {

const t = i18n.t;



return (_ctx: any,_cache: any) => {
  return (_ctx.isError && _ctx.errorMessage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(t)(_ctx.errorMessage)), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})